import { H2 } from "~/components/Text";

export default function Imprint() {
  return (
    <div className="prose prose-invert">
      <H2>Impressum</H2>

      <h3>Angaben gemäß § 5 TMG</h3>
      <p>
        Felix Gerschau
        <br />
        Im Auel 12
        <br />
        51766 Engelskirchen
        <br />
        Deutschland
      </p>

      <h3>Kontakt</h3>
      <p>
        E-Mail: me@felixgerschau.com
      </p>

      <h3>Hinweis gemäß § 19 UStG (Kleinunternehmerregelung)</h3>
      <p>
        Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.
      </p>
    </div>
  );
}
